import HELPERS from '../../../lib/globals/helpers/Helpers';

class Light {
	constructor(vc, x, y) {
		this.vc = vc;
		this.light = HELPERS.getAnimatedSprite({
			pattern: 'booklight_000$.png',
			start: 0,
			end: 50,
			speed: 0.5,
			precision: 2,
			loop: true
		});
		this.light.gotoAndPlay(0);
		this.light.position.x = x;
		this.light.position.y = y;
		this.vc.addChild(this.light);
		return this.light;
	}
}

export default Light;
